import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from '../../core/components';
import { CommonService } from '../../services';
import { EmailTemplateListComponent } from './email-template-list.component';

@Component({
    selector: 'app-email-templates',
    templateUrl: './email-template.component.html',
    styleUrls: ['../layout/layout.component.scss']
})
export class EmailTemplateComponent extends BaseComponent implements OnInit {
    @ViewChild('emailTemplates') emailTemplates: EmailTemplateListComponent;
    public isAdminOrUserEditor = false;
    public isSuperAdmin = false;

    public selectedLanugeId: number = 0;
    public selectedModuleId: number = 0;

    public languages: any = [];
    public modules: any = [];
    constructor(
        private commonService: CommonService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location) {
        super(router);
    }

    public ngOnInit(): void {
        let currentUser = super.currentLoggedUser();
        if (currentUser.role === 'admin') {
            this.isAdminOrUserEditor = true;
        }
        else if (currentUser.role === 'superadmin') {
            this.isSuperAdmin = true;
        }
        this.getAllLanguages();
        this.getAllActiveModules();
        this.emailTemplates.loadData();
    }

    public getAllLanguages() {
        this.commonService.getAllLanguages()
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {

            })
            .subscribe((response: any) => {
                this.languages = response.Data;
            });
    }

    public getAllActiveModules() {
        this.commonService.getAllActiveModules()
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {

            })
            .subscribe((response: any) => {
                this.modules = response.Data;
            });
    }

    public triggerModuleFilter(e) {
        let value = Number(e.value);
        this.selectedModuleId = value;
        if (this.selectedLanugeId) {
            this.emailTemplates.loadData(this.selectedLanugeId, value);
        }
        else {
            this.emailTemplates.loadData(1, value);
        }

    }

    public triggerLanguageFilter(e) {
        let value = Number(e.value);
        this.selectedLanugeId = value;
        if (this.selectedModuleId) {
            this.emailTemplates.loadData(value, this.selectedModuleId);
        }
        else {
            this.emailTemplates.loadData(value, 0);
        }

    }

    public emailTempateListView() {
        this.emailTemplates.loadData(this.selectedLanugeId, this.selectedModuleId);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/email/email-template.component.ts